import Link from 'next/link';
import Image from 'next/image';
import { Container } from './Container';
import { HeaderNav } from './HeaderNav';
import { Icon } from '../ui';
import { HomeOptions } from '../ui/HomeOptions';
import { Button } from '@workspace/ui/components/button';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export function HeaderServer({ children, className }: Props) {
  return (
    <header className="w-full sticky top-0 md:pl-6 md:pr-9 px-4 py-0 bg-white z-50 h-[50px] md:h-[67px] flex-shrink-0">
      <Container className="flex items-center justify-between mx-auto h-full">
        <div className="md:flex hidden gap-20 items-center">
          <div className="flex gap-8 items-center">
            <Link href="/">
              <Image
                src="/icons/logoHero.png"
                alt="logo"
                width={40}
                height={40}
                priority
                className="object-contain"
              />
            </Link>
            <Link href="/" className={className}>
              <Image
                src="/icons/logo.svg"
                alt="logo"
                width={115}
                height={19}
                priority
                className="object-contain w-[115px] h-auto"
              />
            </Link>
            <HomeOptions>
              <Button variant="ghost" size="icon">
                <Icon name="dots" className="size-4 text-black" />
              </Button>
            </HomeOptions>
          </div>
        </div>
        {children}
        <div className="md:flex hidden items-center justify-end">
          <HeaderNav />
        </div>
      </Container>
    </header>
  );
}
